export const BASE_NOTIFICATIONS_URL = '/v1/notifications';

export const EMAIL_BY_ID = `${BASE_NOTIFICATIONS_URL}/:id`;
export const SEND_EMAIL_VALIDATION = `${BASE_NOTIFICATIONS_URL}/email-validation`;
export const VERIFY_VALIDATION_EMAIL = `${BASE_NOTIFICATIONS_URL}/email-verification`;
export const VERIFY_INMAIL_RECORD = `${BASE_NOTIFICATIONS_URL}/verify-inmail-record`;
export const SET_MAIL_FROM = `${BASE_NOTIFICATIONS_URL}/mail-from`;

export const WHATSAPP_BASE_URL = `${BASE_NOTIFICATIONS_URL}/whatsapp`;
export const WHATSAPP_NOTIFICATIONS_URL = `${WHATSAPP_BASE_URL}/notifications`;
export const WHATSAPP_NOTIFICATION_BY_ID_URL = `${WHATSAPP_NOTIFICATIONS_URL}/:id`;
export const WHATSAPP_SETTINGS_URL = `${WHATSAPP_BASE_URL}/settings`;
export const WHATSAPP_CREDITS_PACKS_URL = `${WHATSAPP_BASE_URL}/credits/packs`;
export const WHATSAPP_CREDITS_BALANCE_URL = `${WHATSAPP_BASE_URL}/credits/balance`;
export const WHATSAPP_PURCHASES_URL = `${WHATSAPP_BASE_URL}/purchases`;
export const WHATSAPP_PURCHASE_SYNC_URL = `${WHATSAPP_PURCHASES_URL}/:id/sync`;
export const WHATSAPP_TEMPLATE_BY_ID_URL = `${WHATSAPP_BASE_URL}/templates/:id`;

export const emailEndpoints = {
  getEmailsList: 'getEmailsList',
  getEmail: 'getEmail',
  updateEmail: 'updateEmail',
  partialUpdateEmail: 'partialUpdateEmail',
  sendEmailValidation: 'sendEmailValidation',
  verifyValidationEmail: 'verifyValidationEmail',
  verifyInmailRecord: 'verifyInmailRecord',
  setMailFrom: 'setMailFrom',
} as const;

export const emailTags = {
  emailsList: 'emailsList',
} as const;

export const whatsappEndpoints = {
  getNotificationList: 'getWhatsappNotificationList',
  getNotificationById: 'getWhatsappNotificationById',
  updateNotificationById: 'updateWhatsappNotificationById',
  getNotificationSettings: 'getWhatsappNotificationSettings',
  getCreditsPacks: 'getWhatsappCreditsPacks',
  getCreditsBalance: 'getWhatsappCreditsBalance',
  getPurchases: 'getWhatsappPurchases',
  createPurchase: 'createWhatsappPurchase',
  syncPurchase: 'syncWhatsappPurchase',
  getTemplateById: 'getWhatsappTemplateById',
} as const;

export const whatsappTags = {
  notificationSettings: 'whatsappNotificationSettings',
  notification: 'whatsappNotification',
  notifications: 'whatsappNotifications',
  creditsPacks: 'whatsappCreditsPacks',
  creditsBalance: 'whatsappCreditsBalance',
  purchases: 'whatsappPurchases',
  template: 'whatsappTemplate',
} as const;

export const VERIFY_VALIDATION_EMAIL_CACHE_KEY =
  emailEndpoints.verifyValidationEmail;
